import { render, staticRenderFns } from "./SettingModule.vue?vue&type=template&id=4c656c27&scoped=true"
import script from "./SettingModule.vue?vue&type=script&lang=js"
export * from "./SettingModule.vue?vue&type=script&lang=js"
import style0 from "./SettingModule.vue?vue&type=style&index=0&id=4c656c27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c656c27",
  null
  
)

export default component.exports